/**
 * 常設シートのヘッダー
 *
 * 地図を背景にした画面はシートの中身をモードで差し替えるため、どのモードでも
 * 「戻る / 見出し / 主操作」の並びを崩さないようにここへ集約する。
 */

import { ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type Props = {
  /** 渡すと左に戻るボタンを出す。一覧は戻り先がないので渡さない */
  onBack?: () => void
  title: ReactNode
  action?: ReactNode
  className?: string
}

export const SheetNavHeader = ({ onBack, title, action, className }: Props) => (
  <div className={cn('flex items-center gap-2 border-b py-2', onBack ? 'px-2' : 'px-3', className)}>
    {onBack && (
      <Button variant="ghost" size="icon" className="shrink-0 p-2!" aria-label="戻る" onClick={onBack}>
        <ChevronLeft size={20} />
      </Button>
    )}
    <span className="min-w-0 flex-1 truncate text-sm font-medium">{title}</span>
    {action}
  </div>
)
